import { render, staticRenderFns } from "./StartsExpires.vue?vue&type=template&id=4fe37b2a&"
import script from "./StartsExpires.vue?vue&type=script&lang=js&"
export * from "./StartsExpires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports